import React from 'react';
import { bool, string } from 'prop-types';
import { Box, Tooltip } from '@mui/material';

import { alertTriangleIcon } from '../../../../../../../../../../assets/icons';
import { Chip } from '../../../../../../../../../../components';

const errorHint = {
  text: 'Inactive due to a repeated number of error responses from your callback URI.',
  children: { iconSrc: alertTriangleIcon, alt: 'error' },
};

const Status = ({ statusText, hasError, disabled }) => {
  const getStatusType = (type) => {
    switch (type) {
      case 'enabled':
      case 'active':
        return 'success';
      case 'unverified':
      case 'error':
        return 'error';
      default:
        return 'status';
    }
  };
  return (
    <Box display="flex" alignItems="center" sx={{ opacity: disabled ? 0.5 : 1 }}>
      <Chip label={statusText} type={getStatusType(statusText.toLowerCase())} />
      {hasError ? (
        <Box sx={{ ml: 1, display: 'flex' }}>
          <Tooltip title={errorHint.text} placement="top" arrow>
            <img src={alertTriangleIcon} alt="error" />
          </Tooltip>
        </Box>
      ) : null}
    </Box>
  );
};

export default Status;

Status.propTypes = {
  statusText: string.isRequired,
  hasError: bool.isRequired,
  disabled: bool,
};

Status.defaultProps = {
  disabled: false,
};
